import React, { useEffect, useState } from 'react'

export default function QuestionnaireInput({
  name,
  type,
  questionOptions,
  onChange,
  formData,
}: {
  name: string
  type: string
  questionOptions: any[]
  onChange: Function
  formData: any
}) {
  const [value, setValue] = useState<any>('')

  useEffect(() => {
    if (formData) {
      const parsedValue = formData === undefined ? '' : formData.parsedValue
      setValue(parsedValue)
    } else {
      setValue(null)
    }
  }, [formData])

  const prepareAnswer = (
    e: React.ChangeEvent<any>,
    value: {
      string: string | null
      boolean: boolean | null
      numeric: string | null
      array: any[] | string[] | null
      date: string | null
    },
  ) => {
    onChange(e, value)
  }

  switch (type) {
    case 'numeric':
      return (
        <React.Fragment>
          <input
            name={name}
            type='number'
            onChange={e =>
              prepareAnswer(e, {
                string: null,
                boolean: null,
                numeric: e.target.value,
                array: null,
                date: null,
              })
            }
            value={value}
          ></input>
        </React.Fragment>
      )
    case 'boolean':
      return (
        <input
          name={name}
          type='checkbox'
          onChange={e =>
            prepareAnswer(e, {
              string: null,
              boolean: e.target.checked,
              numeric: null,
              array: null,
              date: null,
            })
          }
          value={value}
        ></input>
      )
    case 'checkBox':
      return (
        <>
          {questionOptions.map(item => (
            <div>
              <input
                id={item.id}
                type='checkbox'
                name={name}
                onChange={e =>
                  prepareAnswer(e, {
                    string: null,
                    boolean: null,
                    numeric: null,
                    array: formData[name].array ? [...formData[name].array, item.id] : [item.id],
                    date: null,
                  })
                }
                value={value}
              ></input>
              <label htmlFor={item.id}>{item.label}</label>
            </div>
          ))}
        </>
      )
    case 'date':
      return (
        <input
          name={name}
          onChange={e =>
            prepareAnswer(e, {
              string: null,
              boolean: null,
              numeric: null,
              array: null,
              date: e.target.value,
            })
          }
          value={value}
        ></input>
      )
    case 'freeText':
      return (
        <textarea
          name={name}
          onChange={e =>
            prepareAnswer(e, {
              string: e.target.value,
              boolean: null,
              numeric: null,
              array: null,
              date: null,
            })
          }
          value={value}
        ></textarea>
      )
    case 'optionButton':
      return (
        <>
          {questionOptions.map(item => (
            <div>
              <input
                id={item.id}
                type='radio'
                name={name}
                onChange={e =>
                  prepareAnswer(e, {
                    string: null,
                    boolean: null,
                    numeric: null,
                    array: [item.id],
                    date: null,
                  })
                }
                value={value}
              ></input>
              <label htmlFor={item.id}>{item.label}</label>
            </div>
          ))}
        </>
      )
    case 'select':
      return (
        <div>
          <select
            name={name}
            value={value}
            onChange={e =>
              prepareAnswer(e, {
                string: null,
                boolean: null,
                numeric: null,
                array: [e.target.value],
                date: null,
              })
            }
          >
            <option selected>Selecione</option>
            {questionOptions.map(item => (
              <option value={item.id}>{item.label}</option>
            ))}
          </select>
        </div>
      )
    default:
      return <>Componente Desconhecido</>
  }
}
